var component = require('../../../lib/js/component.js');

function VerticalTabs() {
    this.initialize = function (element, options) {
        var $element = $(element);
        var _this = this;
       
        _this.$verticalTabs = $element.find('.vertical-tab-container');
        _this.$accordionArrow = _this.$verticalTabs.find('.accordion-arrow');
        _this.$verticalNavTabsList = $element.find('.vertical-tabs');
        _this.$allVerticalTabs = _this.$verticalTabs.find('.vertical-tab');
        _this.$verticalMobile = $element.find('.vertical-tabs-mobile');
        _this.$collapseMobile = _this.$verticalTabs.find('.panel-collapse');
        _this.$titlePanel = $element.find('.verticalMobile-title');
        _this.$panelTitle = _this.$verticalTabs.find('.panel-title');

        _this.$images = _this.$element.find('img');
        
        var $firstVerticalTab = _this.$verticalTabs.find('.vertical-tab:first');
        var $firstVerticalMobileTab = _this.$verticalMobile.find('.vertical-tab:first');
        var $firstVerticalTabContent = _this.$verticalTabs.find('.vertical-tab-content:first');
        var $sectionTabContent = $element.find('.vertical-tab-content');
        var $tabCards = $element.find('.Card-container');
        var deeplinkScrollToId = element.id;
        var HorizontalTabContainer = $element.parents('.HorizontalTabs');
        var $firstVerticalTabChild = $firstVerticalTab.children();

        // If a Horizontal Tab Container exists as a parent of the vertical tab container, use the ID of the Horizontal Tab Container for deeplink scrolling
        // and set the deeplink scrollto of the Vertical Tab Container
        if (HorizontalTabContainer != null && HorizontalTabContainer.length > 0) {
            deeplinkScrollToId = HorizontalTabContainer[0].id;

            $element.attr("data-deeplink-scrollto", '#' + deeplinkScrollToId);
        }

        // Add the Vertical Tabs section Id as the data-deeplink-scrollto value to each vertical tab and tab card
        $sectionTabContent.each(function () {
            $(this).attr("data-deeplink-scrollto", '#' + deeplinkScrollToId);
        });

        $tabCards.each(function() {
            $(this).attr("data-deeplink-scrollto", '#' + deeplinkScrollToId);
        });

        $firstVerticalTab.addClass('active');
        $firstVerticalTabContent.addClass('active');
        $firstVerticalTab.attr('aria-selected', 'true');
        $firstVerticalMobileTab.attr('aria-selected', 'true');

        // Load the first image
        if(_this.$images != null && _this.$images.length != 0) {
            $.cloudinary.responsive();
        }

        // When not in experience editor, restructure HTML for bootstrap tabs
        if (!_this.$verticalTabs.hasClass('expEditorEditing')) {
            $cloneToAppend = _this.$allVerticalTabs.clone();
            $cloneToAppend.detach().appendTo(_this.$verticalMobile);
            _this.$allVerticalTabs.detach().appendTo(_this.$verticalNavTabsList);
        }

        _this.$titlePanel[0].innerHTML = $firstVerticalTab.first().text();

        _this.$verticalMobileToggle = $element.find('.vertical-tabs-mobile li');

        _this.$collapseMobile.on('show.bs.collapse hide.bs.collapse', function () {
            _this.$accordionArrow.toggleClass('flip-arrow');
        });
        _this.$allVerticalTabs.on('click touch', _this.activeToggle.bind(_this));
        _this.$verticalMobileToggle.on('click touch', _this.activeToggleMobile.bind(_this));
        _this.$element.on('vt-tab-change', _this.selectTabByElement.bind(_this));

        _this.$allVerticalTabs.on("keydown", function(e) {
            e.preventDefault();
            var listTabs = _this.$allVerticalTabs;
            var prevActiveTab = $(".vertical-tab.active");
            var TabContent = $(".vertical-tab-content.active");
            var newActiveTab, newTabContent;

            if (e.key === "ArrowUp") {
                if (prevActiveTab.is(listTabs.first())) {
                    newActiveTab = listTabs.last();
                    newTabContent = $(".tab-content .vertical-tab-content").last();
                } else {
                    newActiveTab = prevActiveTab.prev('.vertical-tab');
                    newTabContent = TabContent.prev('.vertical-tab-content');
                }
            } else if (e.key === "ArrowDown") {
                if (prevActiveTab.is(listTabs.last())) {
                    newActiveTab = listTabs.first();
                    newTabContent = $(".tab-content .vertical-tab-content").first();
                } else {
                    newActiveTab = prevActiveTab.next('.vertical-tab');
                    newTabContent = TabContent.next('.vertical-tab-content');
                }
            }

            if (newActiveTab && newTabContent) {
                TabContent.removeClass('active');
                newTabContent.addClass('active');
                prevActiveTab.removeClass('active').attr('aria-selected', 'false');
                newActiveTab.addClass('active').attr('aria-selected', 'true');
            }
        });
    }

    this.activeToggle = function (e) {
        $(".vertical-tab.active").attr('aria-selected', 'false');
        var $clickedTab = $(e.currentTarget.firstElementChild);
        $(e.currentTarget).attr('aria-selected', 'true');
        this.$titlePanel[0].innerHTML = $clickedTab.text();

        this.$verticalMobileToggle.find('a[href="' + $clickedTab[0].hash + '"]').tab('show');
        
        this.refreshTabImage($clickedTab);
    }

    this.activeToggleMobile = function (e) {
        $(".vertical-tab.active").attr('aria-selected', 'false');
        var $clickedTab = $(e.currentTarget.firstElementChild);
        $(e.currentTarget).attr('aria-selected', 'true');
        this.$titlePanel[0].innerHTML = $clickedTab.text();
        this.$collapseMobile.collapse('hide');

        this.$allVerticalTabs.find('a[href="' + $clickedTab[0].hash + '"]').tab('show');
        
        this.refreshTabImage($clickedTab);
    }

    this.deeplink = function (event, val) {
        var $deeplinkElement = $(event.currentTarget.firstElementChild).find('[data-deeplink="' + val + '"]');

        this.selectTabByElement(null, $deeplinkElement);
    }

    this.selectTabByElement = function(e, $selectedElement) {
        if ($selectedElement && $selectedElement.length)
        {
            var $href = null;
            if ($selectedElement.hasClass('Card-container')) {
                tabCardParent = $selectedElement[0].parentElement;
                if (tabCardParent != null) {
                    $href = tabCardParent.id;
                }
            } else {
                $href = $selectedElement[0].id;
            }
            
            if ($href != null) {
                var $tab = this.$verticalTabs.find('a[href="#' + $href + '"]');

                if ($tab.length && $tab[0]) {
                    this.$titlePanel[0].innerHTML = $tab[0].innerHTML;
                    this.$allVerticalTabs.find('a[href="#' + $href + '"]').tab('show');
                    this.$verticalMobileToggle.find('a[href="#' + $href + '"]').tab('show');
                }
            }
        } 
    }

    this.refreshTabImage = function(openTab) {
        // Refresh the card image if it hasn't fully loaded yet
        var $openTabImage = this.find(openTab[0].hash).find('img');
        if($openTabImage != null && !$openTabImage.hasClass('is-fully-loaded')) {
            $openTabImage.cloudinary_update();
            $openTabImage.addClass('is-fully-loaded');
        }
    }
}
module.exports = component(VerticalTabs);
